import { render, staticRenderFns } from "./PickupConfirmDialog.vue?vue&type=template&id=faecdfde&scoped=true"
import script from "./PickupConfirmDialog.vue?vue&type=script&lang=js"
export * from "./PickupConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./PickupConfirmDialog.vue?vue&type=style&index=0&id=faecdfde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faecdfde",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions,QBtn})
